import React from 'react';
import FadeIn from '@components/atoms/FadeIn';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import withApollo from '@lib/withApollo';
import Announcements from '@containers/Announcements';
import brand from '@lib/brand';
const Manage = dynamic(() => import('@containers/Manage'), { ssr: false });
const Alerts = dynamic(() => import('@containers/Alerts'), { ssr: false });

function SessionPage() {
  return (
    <FadeIn>
      <Head>
        <title>{`${brand.brand} | Manage`}</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>
      <Alerts />
      <Announcements />
      <Manage stage={'sessions'} />
    </FadeIn>
  );
}

export default withApollo(SessionPage);
